import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppConfigService } from '@alfresco/adf-core';
import { Observable, forkJoin, from } from 'rxjs';
import _map from 'lodash/map';

import { IPerson, ITrackChange } from '../models';
import { SiteConfigService } from '../../../services/site-config.service';
import { WkAlfrescoApiService } from '../../../services/wk-alfresco-api.service';
import { SiteConfig } from '../../..//types';

import { DecoratorsConstant as DC } from '../const';
@Injectable({
  providedIn: 'root',
})
export class DecoratorsService {
  // #region Properties (1)

  private readonly contentType = ['application/json'];

  // #endregion Properties (1)

  // #region Constructors (1)

  constructor(
    private readonly apiService: WkAlfrescoApiService,
    private readonly siteConfig: SiteConfigService,
    private readonly http: HttpClient,
    private readonly appConfigService: AppConfigService
  ) {}

  // #endregion Constructors (1)

  // #region Public Methods (6)

  public getCurrentSite(): SiteConfig {
    const currentSite = localStorage.getItem(DC.CURRENT_SITE);
    return this.siteConfig.getCurrentSiteObject(currentSite);
  }

  public getNodeContent(nodeId: string): Observable<string> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: `alfresco/api/-default-/public/alfresco/versions/1/nodes/${nodeId}/content`,
        httpMethod: 'GET',
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    );
  }

  public getTrackChangesData(nodeId: string): Observable<ITrackChange> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: `alfresco/s/wk/nodes/${nodeId}/suggestions`,
        httpMethod: 'GET',
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    );
  }

  public getUserDetails(uniqueUsers: string[]): Observable<IPerson[]> {
    return forkJoin<IPerson[]>(
      _map(uniqueUsers, (userId) => this.getUserDetail(userId))
    );
  }

  public getXMLContentFromUrl(url: string): Observable<string> {
    const creds = this.appConfigService.get<boolean>(
      'auth.withCredentials',
      false
    );
    const noCacheHeaders = new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    return this.http.get(url, {
      headers: noCacheHeaders,
      withCredentials: creds,
      responseType: 'text',
    });
  }

  public getOrchestratedData(nodeId: string): Observable<any> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: `alfresco/s/wk/nodes/${nodeId}/orchestrated-properties?fields=all`,
        httpMethod: 'GET',
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    );
  }

  // #endregion Public Methods (6)

  // #region Private Methods (1)

  private getUserDetail(userId: string): Promise<IPerson> {
    return this.apiService.callContentClientCustomApi({
      path: `alfresco/api/-default-/public/alfresco/versions/1/people/${userId}`,
      httpMethod: 'GET',
      contentTypes: this.contentType,
      accepts: this.contentType,
    });
  }

  // #endregion Private Methods (1)
}
